import {Model} from "./Model";
import {IApiRoster} from "../typings/apiResponse";

export class Roster extends Model {

    constructor(private apiData: IApiRoster) {
        super(apiData);
    }

    /**
     * Gets the League ID from the roster data.
     * @returns {number}
     */
    public getLeagueId(): number {
        return this.apiData.leagueId;
    }

    /**
     * Gets the Team ID from the roster data.
     * @returns {number}
     */
    public getTeamId(): number {
        return this.apiData.teamId;
    }

    /**
     * Gets the member ids from the roster.
     * @returns {number[]} Array with userdIds
     */
    public getMemberIds(): number[] {
        return this.apiData.members;
    }
}
